( function( global, $ ) {
    "use strict";

    var PAYMENT_TYPE_CUSTOM = 9;

    var _events = {
        onChangeType: function() {
            $(this).closest('[data-form-field="payment_type"]').trigger('refresh');
        },

        onChangeHasDefaultSpecification: function() {
            var $hasDefaultSpecificationInput = $(this),
                $form = $hasDefaultSpecificationInput.closest('form'),
                $typeField = $form.find('[data-form-field="payment_type"]'),
                $typeInputs = $typeField.find('input[name][type="radio"]'),
                $specificationInput = $form.find('[data-form-control="payment_specification"]'),
                value = $typeInputs.filter(':checked').val(),
                specificationRequired = value == PAYMENT_TYPE_CUSTOM
                    && ! $hasDefaultSpecificationInput.prop('checked');

            $specificationInput.prop('required', specificationRequired);
        },

        onRefreshType: function() {
            var $typeField = $(this),
                $form = $typeField.closest('form[data-form="booking_payment"]'),
                $typeInputs = $typeField.find('input[name][type="radio"]'),
                $specificationField = $form.find('[data-form-field="payment_specification"]'),
                $specificationInput = $form.find('[data-form-control="payment_specification"]'),
                $hasDefaultSpecificationInput = $form.find('[data-form-control="has_default_payment_specification"]'),
                value = $typeInputs.filter(':checked').val();

            $specificationInput.prop('required', false);
            $specificationField.addClass('hidden');

            if (value == PAYMENT_TYPE_CUSTOM) {
                if (! $hasDefaultSpecificationInput.prop('checked')) {
                    $specificationInput.prop('required', true);
                }

                $specificationField.removeClass('hidden');
            }
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form="booking_payment"]'),
            $typeField = $form.find('[data-form-field="payment_type"]'),
            $typeInputs = $typeField.find('input[name][type="radio"]'),
            $hasDefaultSpecificationInput = $form.find('[data-form-control="has_default_payment_specification"]');

        $typeInputs.on('change.bookingpayment', _events.onChangeType);
        $hasDefaultSpecificationInput.on('change.bookingpayment', _events.onChangeHasDefaultSpecification);

        $typeField.on('refresh.bookingpayment', _events.onRefreshType).trigger('refresh');
    });

}( window.groots, jQuery ));
